import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { minisiteGet } from '../utils/minisiteApi';
import MinisiteView from './MinisiteView';
import { useOccasion } from '../utils/minisiteOccasions';
import { useT } from '../i18n';

// Page publique du mini-site de mariage (/i/:slug) : c'est le lien envoyé aux invités (cf.
// l'éditeur, MinisiteEditor.js). Plein écran, sans l'en-tête de la boutique (hideHeader, App.js).
const MinisitePage = () => {
  const { slug } = useParams();
  const t = useT('minisite-view');
  const [minisite, setMinisite] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    minisiteGet('getMinisite', { slug })
      .then((data) => (data?.success ? setMinisite(data.data) : setNotFound(true)))
      .catch(() => setNotFound(true));
  }, [slug]);

  // Langue de la page : celle du réglage `langue` de l'acheteur, appliquée par MinisiteView (jamais celle du
  // navigateur du visiteur, sauf le court message d'attente ou de lien invalide, où le réglage n'est pas connu).
  const params = minisite?.params || {};
  const occasion = useOccasion(params);

  if (notFound) return <p style={{ textAlign: 'center', padding: 48 }}>{t('minisite-view.notFound')}</p>;
  if (!minisite) return <p style={{ textAlign: 'center', padding: 48 }}>{t('minisite-view.loading')}</p>;

  return (
    <>
      <Helmet>
        <title>{[params.prenoms, params.intro || occasion.intro].filter(Boolean).join(' — ')}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <MinisiteView params={params} slug={slug} />
    </>
  );
};

export default MinisitePage;
